import { render } from "./ListSizeComponent.vue?vue&type=template&id=1b9dee3a&ts=true"
import script from "./ListSizeComponent.vue?vue&type=script&lang=ts"
export * from "./ListSizeComponent.vue?vue&type=script&lang=ts"

import "./ListSizeComponent.vue?vue&type=style&index=0&id=1b9dee3a&lang=scss"

import exportComponent from "/codebuild/output/src111513322/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__